import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService, LayoutService, SignalRService, COASSESS_MENU_ITEMS, SessionTimeoutComponent } from 'shared-library';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule, SessionTimeoutComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [MessageService],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'coassess';

  private layoutService = inject(LayoutService);
  logoUrl: string = '';
  authService = inject(AuthService);
  private signalRService = inject(SignalRService);

  ngOnInit() {
    this.layoutService.setSidebarMenuItems(COASSESS_MENU_ITEMS);
  }

  setFavicon(iconUrl: string) {
    const link: HTMLLinkElement =
      document.querySelector("link[rel~='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = iconUrl;
    document.head.appendChild(link);
  }

  ngOnDestroy(): void {
    this.signalRService.destroyConnection();
  }

  continueSession(): void {
    this.authService.refreshToken().subscribe();
  }
}
